import React, { Component } from 'react';
import { Modal, Button, Input, Checkbox, DatePicker, Select, message, Icon } from 'antd';
import moment from 'moment';



const monthFormat = "YYYY-MM";
const { MonthPicker } = DatePicker;

class Filter extends Component {
    state = {
        searchParams: {
            startMonth:moment().format('YYYY-01'),
            endMonth:moment().format('YYYY-MM')
        },
    }

    componentDidMount() {
        const { searchParams } = this.state;
        this.props.search(searchParams)
    }


    search = () => {
        const { searchParams } = this.state;
        const{startMonth,endMonth}=searchParams;
        if(startMonth&&endMonth){
        this.props.search(searchParams);
        }else{
            message.warning('请选择开始月份和结束月份');  
        }
    }

    export = () => {
        this.props.export();
    }


    changeSearchParams = (params) => {
        const { searchParams } = this.state;
        this.setState({ searchParams: { ...searchParams, ...params } });
    }

    handleDateChange = (data, dateString, key) => {
        const { searchParams: { startMonth, endMonth } } = this.state;
        if (key === 'startMonth') {
            if (endMonth) {
                if (moment(dateString).valueOf() > moment(endMonth).valueOf()) {
                    this.changeSearchParams({
                        startMonth: endMonth,
                        endMonth: dateString,
                    });
                    return;
                } 
                // else if (moment(dateString).valueOf() === moment(endMonth).valueOf()) {
                //     message.warning('不能选择单月！');
                //     return;
                // }
            }
            this.changeSearchParams({ [key]: dateString });
        } else if (key === 'endMonth') {
            if (startMonth) {
                if(dateString&&dateString!=""){
                if (moment(dateString).valueOf() < moment(startMonth).valueOf()) {
                    this.changeSearchParams({
                        startMonth: dateString,
                        endMonth: startMonth,
                    });
                    return;
                }
                //  else if (moment(dateString).valueOf() === moment(startMonth).valueOf()) {
                //     message.warning('不能选择单月！');
                //     return;
                // }
                this.changeSearchParams({ [key]: dateString });
               }else{
                    this.changeSearchParams({
                        startMonth: "",
                        endMonth: "",
                    });
               }
            }else{
                this.changeSearchParams({ [key]: dateString }); 
            }
        } else {
            this.changeSearchParams({ [key]: dateString });
        }
    }


    render () {
        const { searchParams: { startMonth, endMonth } } = this.state;
        const{type,exportable}=this.props;
        return (

            <div className="filter-wrap" style={{ padding: 10, background: '#fff' }}>
                {type!="contractPlan"&&
                    <div className="search-item month-range-picker" style={{marginRight:"15px"}}>
                    <label className="ui-label" style={{marginRight:"15px"}}>期间</label>
                    <MonthPicker
                        className="begin"
                        format={monthFormat}
                        value={startMonth ? moment(startMonth) : null}
                        allowClear={false}
                        placeholder="开始月份"
                        onChange={(date, dateString) => this.handleDateChange(date, dateString, 'startMonth')}
                    />
                    <MonthPicker
                        className="end"
                        format={monthFormat}
                        value={endMonth ? moment(endMonth) : null}
                        allowClear={false}
                        placeholder="结束月份"
                        onChange={(date, dateString) => this.handleDateChange(date, dateString, 'endMonth')}
                    />
                </div>
                 }
                 {type!="contractPlan"&&
            <div className="filter-item">
                <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
                }
                <div className="filter-item"> 
                <Button type="primary"  onClick={this.export} disabled={!exportable}>导出</Button>
                </div>
            </div>
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/homePage/revenueVisitAndContractPlan/Filter.js